import React from 'react';

import {FlowchartEditorMode} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/ProcessFlowchartEditorModeConstants';
import {ensureDefaultProcessesPluginRegistered} from 'processes/settings/ProcessTaskSchemaEditor';
import {assertNever} from 'util/Types';

import ACMExecutionFlowchartPane from './ACMExecutionFlowchartPane';
import {ExecutionFlowchartPaneProps} from './ExecutionFlowchartPaneTypes';
import ExecutionViewerFlowchartPane from './ExecutionViewerFlowchartPane';
import PCMExecutionFlowchartPane from './PCMExecutionFlowchartPane';

export type {ExecutionFlowchartPaneProps} from './ExecutionFlowchartPaneTypes';

export default function ExecutionFlowchartPane(props: ExecutionFlowchartPaneProps): JSX.Element {
  ensureDefaultProcessesPluginRegistered({ignoreFlowchartConfigFlag: true});

  switch (props.editorMode) {
    case FlowchartEditorMode.ACM_EDITOR:
      return <ACMExecutionFlowchartPane {...props} />;
    case FlowchartEditorMode.PCM_EDITOR:
      return <PCMExecutionFlowchartPane {...props} />;
    case FlowchartEditorMode.EXECUTION_VIEWER:
      return <ExecutionViewerFlowchartPane {...props} />;
    default:
      return assertNever(props);
  }
}
